import * as i0 from '@angular/core';
import { NgModule, Component, Inject, Injectable, Optional, SkipSelf, Directive, Input, HostListener, APP_INITIALIZER } from '@angular/core';
import * as i4 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i3 from '@angular/material/toolbar';
import { MatToolbarModule } from '@angular/material/toolbar';
import * as i1 from '@angular/material/bottom-sheet';
import { MatBottomSheetModule, MAT_BOTTOM_SHEET_DATA, MAT_BOTTOM_SHEET_DEFAULT_OPTIONS } from '@angular/material/bottom-sheet';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i5 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import { timer, interval, Subject } from 'rxjs';
import { take, map } from 'rxjs/operators';
import * as i2 from '@angular/common';
import * as i2$1 from '@angular/cdk/platform';
import * as i3$1 from '@angular/service-worker';
import { SwRegistrationOptions, ServiceWorkerModule } from '@angular/service-worker';
import * as i4$1 from '@stephaneeybert/lib-core';
import { LibCoreModule } from '@stephaneeybert/lib-core';
import { BrowserModule } from '@angular/platform-browser';

class MaterialModule {
    static ɵfac = function MaterialModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MaterialModule)(); };
    static ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MaterialModule });
    static ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [MatToolbarModule,
            MatIconModule,
            MatTooltipModule,
            MatButtonModule,
            MatBottomSheetModule] });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MaterialModule, [{
        type: NgModule,
        args: [{
                exports: [
                    MatToolbarModule,
                    MatIconModule,
                    MatTooltipModule,
                    MatButtonModule,
                    MatBottomSheetModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(MaterialModule, { exports: [MatToolbarModule,
        MatIconModule,
        MatTooltipModule,
        MatButtonModule,
        MatBottomSheetModule] }); })();

function PwaPromptComponent_mat_toolbar_2_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-toolbar")(1, "button", 2);
    i0.ɵɵlistener("click", function PwaPromptComponent_mat_toolbar_2_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.cancel()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span", 3);
    i0.ɵɵelementStart(4, "button", 4);
    i0.ɵɵlistener("click", function PwaPromptComponent_mat_toolbar_2_Template_button_click_4_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.installPwaAndroid($event)); });
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.i18nCancel, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.i18nInstall, " ");
} }
function PwaPromptComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "button", 6);
    i0.ɵɵlistener("click", function PwaPromptComponent_div_3_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.cancel()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵelement(6, "img", 7);
    i0.ɵɵelementStart(7, "mat-icon");
    i0.ɵɵtext(8, "navigate_next");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "img", 8);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.i18nCancel, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.i18nIOSInstructions);
} }
class PwaPromptComponent {
    ariaLabel;
    data;
    matBottomSheetRef;
    i18nQuestion;
    i18nCancel;
    i18nInstall;
    i18nIOSInstructions;
    constructor(ariaLabel, // TODO
    data, matBottomSheetRef) {
        this.ariaLabel = ariaLabel;
        this.data = data;
        this.matBottomSheetRef = matBottomSheetRef;
    }
    ngOnInit() {
        this.i18nQuestion = this.data.i18nQuestion;
        this.i18nCancel = this.data.i18nCancel;
        this.i18nInstall = this.data.i18nInstall;
        this.i18nIOSInstructions = this.data.i18nIOSInstructions;
    }
    installPwaAndroid(event) {
        console.log(this.data);
        console.log(event);
        this.data.promptEvent.prompt();
        this.data.promptEvent.userChoice.then((userChoice) => {
            switch (userChoice.outcome) {
                case 'accepted':
                    console.log('PWA - User accepted the prompt and installed the app');
                    break;
                case 'dismissed':
                    console.log('PWA - User dismissed the prompt and did not install the app');
                    break;
            }
            this.data.promptEvent = null;
        })
            .catch((error) => {
            console.error("PWA - The user could not be prompted to install the application", error);
        });
        this.cancel();
    }
    cancel() {
        this.matBottomSheetRef.dismiss();
    }
    static ɵfac = function PwaPromptComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PwaPromptComponent)(i0.ɵɵdirectiveInject(MAT_BOTTOM_SHEET_DATA), i0.ɵɵdirectiveInject(MAT_BOTTOM_SHEET_DATA), i0.ɵɵdirectiveInject(i1.MatBottomSheetRef)); };
    static ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PwaPromptComponent, selectors: [["app-pwa-prompt"]], decls: 4, vars: 3, consts: [[4, "ngIf"], ["class", "ios-prompt", 4, "ngIf"], ["mat-flat-button", "", 3, "click"], [1, "fill-remaining-space"], ["mat-flat-button", "", "color", "primary", 3, "click"], [1, "ios-prompt"], ["mat-flat-button", "", 1, "close-ios-inv", 3, "click"], ["src", "assets/pwa/ios/ios-menu-btn.png"], ["src", "assets/pwa/ios/ios-add-btn.png"]], template: function PwaPromptComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar");
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(2, PwaPromptComponent_mat_toolbar_2_Template, 6, 2, "mat-toolbar", 0)(3, PwaPromptComponent_div_3_Template, 10, 2, "div", 1);
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.i18nQuestion, " ");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.data.mobileType === "android");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.data.mobileType === "ios");
        } }, dependencies: [i2.NgIf, i3.MatToolbar, i4.MatIcon, i5.MatButton], styles: [".fill-remaining-space[_ngcontent-%COMP%]{flex:1 1 auto}.ios-prompt[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:space-between;align-items:center}.ios-prompt[_ngcontent-%COMP%]   .close-ios-inv[_ngcontent-%COMP%]{position:absolute;right:0;top:0}.ios-prompt[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{text-align:center;padding:10px 25px 0}.ios-prompt[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{position:relative;top:-7px}.ios-prompt[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{display:inline}"] });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PwaPromptComponent, [{
        type: Component,
        args: [{ selector: 'app-pwa-prompt', template: "  <mat-toolbar>\n    {{ i18nQuestion }}\n  </mat-toolbar>\n  <mat-toolbar *ngIf=\"data.mobileType === 'android'\">\n    <button mat-flat-button (click)=\"cancel()\">\n      {{ i18nCancel }}\n    </button>\n    <span class=\"fill-remaining-space\"></span>\n    <button mat-flat-button color=\"primary\" (click)=\"installPwaAndroid($event)\">\n      {{ i18nInstall }}\n    </button>\n  </mat-toolbar>\n\n  <div *ngIf=\"data.mobileType === 'ios'\" class=\"ios-prompt\">\n    <button mat-flat-button class=\"close-ios-inv\" (click)=\"cancel()\">\n      {{ i18nCancel }}\n    </button>\n    <div>{{ i18nIOSInstructions }}</div>\n    <div><img src=\"assets/pwa/ios/ios-menu-btn.png\">\n      <mat-icon>navigate_next</mat-icon> <img src=\"assets/pwa/ios/ios-add-btn.png\">\n    </div>\n  </div>", styles: [".fill-remaining-space{flex:1 1 auto}.ios-prompt{display:flex;flex-direction:column;justify-content:space-between;align-items:center}.ios-prompt .close-ios-inv{position:absolute;right:0;top:0}.ios-prompt div{text-align:center;padding:10px 25px 0}.ios-prompt div mat-icon{position:relative;top:-7px}.ios-prompt img{display:inline}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [MAT_BOTTOM_SHEET_DATA]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_BOTTOM_SHEET_DATA]
            }] }, { type: i1.MatBottomSheetRef }], null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(PwaPromptComponent, { className: "PwaPromptComponent", filePath: "lib/pwa-prompt.component.ts", lineNumber: 23 }); })();

const CHECK_FOR_INSTALL_DELAY = 5000;
const OFFER_TO_INSTALL_DELAY = 15000;
const PLATFORM_ANDROID = 'android';
const PLATFORM_IOS = 'ios';
const SW_UPDATE_VERSION_READY = 'VERSION_READY';
class PwaService {
    matBottomSheet;
    platform;
    swUpdate;
    screenDeviceService;
    environment;
    installPromptEvent;
    alreadyInstalledEvent;
    pwaPromptForInstallSubscription;
    pwaCheckForUpdateSubscription;
    afterDismissedSubscription;
    constructor(
    // Ensure the service is injected only once
    pwaService, matBottomSheet, platform, swUpdate, screenDeviceService) {
        this.matBottomSheet = matBottomSheet;
        this.platform = platform;
        this.swUpdate = swUpdate;
        this.screenDeviceService = screenDeviceService;
        if (pwaService) {
            throw new Error('The PWA service has ALREADY been injected.');
        }
    }
    ngOnDestroy() {
        if (this.pwaPromptForInstallSubscription != null) {
            this.pwaPromptForInstallSubscription.unsubscribe();
        }
        if (this.pwaCheckForUpdateSubscription != null) {
            this.pwaCheckForUpdateSubscription.unsubscribe();
        }
        if (this.afterDismissedSubscription != null) {
            this.afterDismissedSubscription.unsubscribe();
        }
        window.removeEventListener('beforeinstallprompt', this.handleBbeforeInstallAndroid);
        window.removeEventListener('appinstalled', this.handleAlreadyInstalledAndroid);
        self.removeEventListener('install', this.handleServiceWorkerInstallEvent);
        self.removeEventListener('fetch', this.handleServiceWorkerFetchEvent);
    }
    setEnvironment(environment) {
        this.environment = environment;
    }
    displayPwaInstallPrompt(i18nQuestion, i18nCancel, i18nInstall, i18nIOSInstructions) {
        if (this.platform.ANDROID) {
            if (!this.isInStandaloneModeAndroid()) {
                console.log('PWA - Opening the propt install on Android');
                const matBottomSheet = this.createBottomSheet(PLATFORM_ANDROID, i18nQuestion, i18nCancel, i18nInstall, '');
                this.openBottomSheet(matBottomSheet);
            }
        }
        else if (this.platform.IOS) {
            if (!this.isInStandaloneModeIOS()) {
                // Prevent the installation prompt when the app is already installed
                console.log('PWA - Opening the propt install on iOS');
                const matBottomSheet = this.createBottomSheet(PLATFORM_IOS, i18nQuestion, i18nCancel, '', i18nIOSInstructions);
                this.openBottomSheet(matBottomSheet);
            }
        }
        else {
            console.log('PWA - The platform is not supporting PWA installation');
        }
    }
    checkForBeforeInstallEvents() {
        if (this.platform.ANDROID) {
            if (!this.isInStandaloneModeAndroid()) {
                console.log('PWA - Listening on the install prompt event on Android');
                // Explicitly bind the service instance this reference to the handler
                // as the default this keyword in event handler functions references
                // the DOM window and not the class instance
                window.addEventListener('beforeinstallprompt', this.handleBbeforeInstallAndroid.bind(this));
                window.addEventListener('appinstalled', this.handleAlreadyInstalledAndroid.bind(this));
                self.addEventListener('install', this.handleServiceWorkerInstallEvent.bind(this));
                self.addEventListener('fetch', this.handleServiceWorkerFetchEvent.bind(this));
            }
        }
        else if (this.platform.IOS) {
        }
        else {
        }
    }
    // Called if the application is sent an event before offering the user to install it on the device
    handleBbeforeInstallAndroid(event) {
        // Prevent the default dialog from opening before our custom dialog
        event.preventDefault();
        // Keep the install prompt event for latter use
        this.installPromptEvent = event;
    }
    autoDisplayPwaInstallPrompt(i18nQuestion, i18nCancel, i18nInstall, i18nIOSInstructions) {
        this.pwaPromptForInstallSubscription = timer(OFFER_TO_INSTALL_DELAY)
            .pipe(take(1))
            .subscribe(() => {
            if (this.isInstallable() && this.isOfferedAutomaticallyForInstallation()) {
                this.displayPwaInstallPrompt(i18nQuestion, i18nCancel, i18nInstall, i18nIOSInstructions);
            }
        });
    }
    // Called if the application if already installed
    handleAlreadyInstalledAndroid(event) {
        console.log('PWA - In handleAlreadyInstalledAndroid');
        console.log(event);
        this.alreadyInstalledEvent = event;
        console.log(this.alreadyInstalledEvent);
    }
    // TODO Do I need this method ?
    // Called when the service worker receives an install event
    handleServiceWorkerInstallEvent(event) {
        console.log('PWA - In handleServiceWorkerInstallEvent');
        console.log(event);
        event.waitUntil(caches.open('v1').then(function (cache) {
            console.log('PWA - Caching custom resources for the service worker');
            return cache.addAll([
                './index.html', // Caching the resource specified in the start_url in the manifest file
                // is a prerequisite to receiving the beforeinstallprompt event from the browser
            ]);
        }));
    }
    // Called when the service worker receives a fetch event
    // Listening to the fetch event is a prerequisite to receiving the beforeinstallprompt event from the browser
    handleServiceWorkerFetchEvent(event) {
        console.log('PWA - In handleServiceWorkerFetchEvent');
        console.log(event);
        event.respondWith(caches.match(event.request).then(function (response) {
            if (response) {
                console.log('PWA - Found response in cache:', response);
                return response;
            }
            console.log('PWA - No response found in cache. About to fetch from network...');
            return fetch(event.request).then(function (response) {
                console.log('PWA - Response from network is:', response);
                return response;
            }, function (error) {
                console.error('PWA - Fetching failed:', error);
                throw error;
            });
        }));
    }
    fakeBottomSheet() {
        const i18nQuestion = 'Install on the device ?';
        const i18nCancel = 'CANCEL';
        const i18nInstall = 'INSTALL';
        const i18nIOSInstructions = "To install this web app on your device, tap the Menu button and the 'Add to Home screen' button";
        const matBottomSheet = this.createBottomSheet(PLATFORM_ANDROID, i18nQuestion, i18nCancel, i18nInstall, i18nIOSInstructions);
        this.openBottomSheet(matBottomSheet);
    }
    createBottomSheet(mobilePlatform, i18nQuestion, i18nCancel, i18nInstall, i18nIOSInstructions) {
        return this.matBottomSheet.open(PwaPromptComponent, {
            ariaLabel: '', // TODO I'm not sure this label is actually used
            data: {
                mobileType: mobilePlatform,
                promptEvent: this.installPromptEvent,
                i18nQuestion: i18nQuestion,
                i18nCancel: i18nCancel,
                i18nInstall: i18nInstall,
                i18nIOSInstructions: i18nIOSInstructions
            }
        });
    }
    openBottomSheet(bottomSheetRef) {
        this.afterDismissedSubscription = bottomSheetRef.afterDismissed()
            .subscribe((data) => {
            console.log('PWA - The bottom sheet has been dismissed.');
        });
    }
    receivedInstallPromptEventAndroid() {
        return this.installPromptEvent != null;
    }
    isInStandaloneModeAndroid() {
        return matchMedia('(display-mode: standalone)').matches;
    }
    isNotAutomaticallyOfferedForInstallation$() {
        return interval(CHECK_FOR_INSTALL_DELAY)
            .pipe(take(3), map((value) => {
            return this.isInstallable() && !this.isOfferedAutomaticallyForInstallation();
        }));
    }
    isOfferedAutomaticallyForInstallation() {
        if (this.environment) {
            return this.environment.pwaInstallPromptAutoDisplay;
        }
        else {
            throw new Error('Set the environment using the setEnvironment setter before accessing the environment variables');
        }
    }
    isInstallable() {
        if (this.platform.ANDROID) {
            return this.receivedInstallPromptEventAndroid() && !this.isInStandaloneModeAndroid();
        }
        else if (this.platform.IOS) {
            return this.isInStandaloneModeIOS();
        }
        else {
            return false;
        }
    }
    isInStandaloneModeIOS() {
        return (window.matchMedia('(display-mode: standalone)').matches);
    }
    checkForAppUpdate(i18nNewVersionAvailable) {
        if (this.swUpdate.isEnabled) {
            this.pwaCheckForUpdateSubscription = this.swUpdate.versionUpdates
                .subscribe((event) => {
                if (event.type === SW_UPDATE_VERSION_READY && confirm(i18nNewVersionAvailable)) {
                    this.screenDeviceService.reloadPage();
                }
            });
        }
    }
    static ɵfac = function PwaService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PwaService)(i0.ɵɵinject(PwaService, 12), i0.ɵɵinject(i1.MatBottomSheet), i0.ɵɵinject(i2$1.Platform), i0.ɵɵinject(i3$1.SwUpdate), i0.ɵɵinject(i4$1.ScreenDeviceService)); };
    static ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PwaService, factory: PwaService.ɵfac, providedIn: 'root' });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PwaService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: PwaService, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }, { type: i1.MatBottomSheet }, { type: i2$1.Platform }, { type: i3$1.SwUpdate }, { type: i4$1.ScreenDeviceService }], null); })();

class PwaPromptDirective {
    elementRef;
    pwaService;
    screenDeviceService;
    i18nQuestion = '';
    i18nCancel = '';
    i18nInstall = '';
    i18nIOSInstructions = '';
    clicks = new Subject();
    clickSubscription;
    isPromptableForInstallationSubscription;
    constructor(elementRef, pwaService, screenDeviceService) {
        this.elementRef = elementRef;
        this.pwaService = pwaService;
        this.screenDeviceService = screenDeviceService;
    }
    ngOnInit() {
        this.isPromptableForInstallation();
        // Handle a click on the element containing the directive
        this.clickSubscription = this.clicks
            .subscribe((event) => {
            this.pwaService.displayPwaInstallPrompt(this.i18nQuestion, this.i18nCancel, this.i18nInstall, this.i18nIOSInstructions);
        });
    }
    ngOnDestroy() {
        if (this.isPromptableForInstallationSubscription) {
            this.isPromptableForInstallationSubscription.unsubscribe();
        }
        if (this.clickSubscription) {
            this.clickSubscription.unsubscribe();
        }
    }
    onClickEvent(event) {
        event.preventDefault();
        event.stopPropagation();
        this.clicks.next(event);
    }
    isPromptableForInstallation() {
        this.screenDeviceService.hideElement(this.elementRef);
        this.isPromptableForInstallationSubscription = this.pwaService.isNotAutomaticallyOfferedForInstallation$()
            .subscribe((isPromptable) => {
            if (isPromptable) {
                console.log('PWA - Showing directive element');
                this.screenDeviceService.showElement(this.elementRef);
            }
            else {
                console.log('PWA - Hiding directive element');
                this.screenDeviceService.hideElement(this.elementRef);
            }
        });
    }
    static ɵfac = function PwaPromptDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PwaPromptDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(PwaService), i0.ɵɵdirectiveInject(i4$1.ScreenDeviceService)); };
    static ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: PwaPromptDirective, selectors: [["", "appPwaPrompt", ""]], hostBindings: function PwaPromptDirective_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("click", function PwaPromptDirective_click_HostBindingHandler($event) { return ctx.onClickEvent($event); });
        } }, inputs: { i18nQuestion: "i18nQuestion", i18nCancel: "i18nCancel", i18nInstall: "i18nInstall", i18nIOSInstructions: "i18nIOSInstructions" } });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PwaPromptDirective, [{
        type: Directive,
        args: [{
                selector: '[appPwaPrompt]'
            }]
    }], () => [{ type: i0.ElementRef }, { type: PwaService }, { type: i4$1.ScreenDeviceService }], { i18nQuestion: [{
            type: Input
        }], i18nCancel: [{
            type: Input
        }], i18nInstall: [{
            type: Input
        }], i18nIOSInstructions: [{
            type: Input
        }], onClickEvent: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();

function serviceWorkerFactory(environment) {
    const isProduction = environment.production;
    return ({
        enabled: isProduction
    });
}
;
class SWModule {
    static ɵfac = function SWModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SWModule)(); };
    static ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SWModule });
    static ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            {
                provide: SwRegistrationOptions,
                useFactory: serviceWorkerFactory,
                deps: []
            }
        ], imports: [ServiceWorkerModule.register('ngsw-worker.js')] });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SWModule, [{
        type: NgModule,
        args: [{
                imports: [
                    ServiceWorkerModule.register('ngsw-worker.js')
                ],
                providers: [
                    {
                        provide: SwRegistrationOptions,
                        useFactory: serviceWorkerFactory,
                        deps: []
                    }
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SWModule, { imports: [i3$1.ServiceWorkerModule] }); })();

const checkForBeforeInstallEvents = (pwaService) => () => pwaService.checkForBeforeInstallEvents();
class LibPwaModule {
    static ɵfac = function LibPwaModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LibPwaModule)(); };
    static ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: LibPwaModule });
    static ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            {
                provide: MAT_BOTTOM_SHEET_DEFAULT_OPTIONS,
                useValue: {
                    hasBackdrop: false
                }
            },
            {
                provide: APP_INITIALIZER,
                useFactory: checkForBeforeInstallEvents,
                deps: [PwaService],
                multi: true
            }
        ], imports: [BrowserModule,
            MaterialModule,
            LibCoreModule,
            SWModule, BrowserModule,
            MaterialModule] });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibPwaModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    PwaPromptDirective,
                    PwaPromptComponent
                ],
                imports: [
                    BrowserModule,
                    MaterialModule,
                    LibCoreModule,
                    SWModule
                ],
                exports: [
                    BrowserModule,
                    MaterialModule,
                    PwaPromptDirective,
                    PwaPromptComponent
                ],
                providers: [
                    {
                        provide: MAT_BOTTOM_SHEET_DEFAULT_OPTIONS,
                        useValue: {
                            hasBackdrop: false
                        }
                    },
                    {
                        provide: APP_INITIALIZER,
                        useFactory: checkForBeforeInstallEvents,
                        deps: [PwaService],
                        multi: true
                    }
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LibPwaModule, { declarations: [PwaPromptDirective,
        PwaPromptComponent], imports: [BrowserModule,
        MaterialModule,
        LibCoreModule,
        SWModule], exports: [BrowserModule,
        MaterialModule,
        PwaPromptDirective,
        PwaPromptComponent] }); })();

/*
 * Public API Surface of lib-pwa
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LibPwaModule, MaterialModule, PwaPromptComponent, PwaPromptDirective, PwaService };
